import React, { useEffect, useState } from 'react';
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  Checkbox,
  Typography,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import translations from '../../../languages/i18n';

import { varStyles } from '../../../styles/formElementsStyles';

function Multiple({ handleResult, handleResultMultiple, options, sharedId, field, form: { errors } }) {
  const [showError, setShowError] = useState(errors[field.name] ? true : false); // ATENCIÓ: no canviar per errors[field.name] || false ja que dins showError hi ha d'haver un boolea i si field.name existex llavors errors[field.name] no és un boolea sinó un string
  // const [valuesArray, setValuesArray] = useState([]);
  const [valuesArray, setValuesArray] = useState(field.value || []);

  const varStyle = varStyles();

  useEffect(() => {
    setShowError(errors[field.name] ? true : false); // ATENCIÓ: no canviar per errors[field.name] || false ja que dins showError hi ha d'haver un boolea i si field.name existex llavors errors[field.name] no és un boolea sinó un string
  }, [errors[field.name]]);

  const handleChange = (event) => {
    const valuesArrayCopy = valuesArray.slice();
    // Cercam si dins initialArray hi ha el valor d'option
    const idx = valuesArrayCopy.findIndex((item) => item === event.target.value);
    if (idx < 0) valuesArrayCopy.push(event.target.value); // Si idx és -1 vol dir que no ha trobat el valor, l'afegim a la taula
    else valuesArrayCopy.splice(idx, 1); // L'ha trobat l'eliminam de la taula
    if (valuesArrayCopy.length === 0) { // Necessari ja que [errors[field.name]] no canvia de valor fins que no es fa validate al formulari
      setShowError(true);
    } else {
      setShowError(false);
    }
    handleResult(event);
    handleResultMultiple(valuesArrayCopy); // Necessari per passar al camp Field de Formik que fa de pare, el valor dels checkboxs
    setValuesArray(valuesArrayCopy);
  };


  return (
    <Grid container direction='column' justify='flex-start' spacing={2}>
      <Grid item xs={6}>
        {translations[`_t01${sharedId}`] && <Typography variant='h6' component='div' className={varStyle.title}>{translations[`_t01${sharedId}`]}</Typography>}
        {translations[`_t02${sharedId}`] && <Typography variant='body1' component='div' className={varStyle.subTitle}>{translations[`_t02${sharedId}`]}</Typography>}
        <Typography variant='body1' component='div'>
          {translations[`_q${sharedId}`].split("\n").map((i, key) => {
            return <div key={key}>{i}</div>;
              })} 
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <FormControl component='fieldset'>
          {/* <FormLabel component='legend'>{translations[`_${sharedId}`] || sharedId}</FormLabel> */} {/* Si la variable no està traduida, es mostra el shareId */}
          <FormGroup>
            {options.map((option) => (
              <FormControlLabel
                key={`${sharedId}_${option}`}
                value={option}
                id={sharedId}
                name={sharedId}
                onChange={handleChange}
                control={(
                  <Checkbox
                    title={option}
                    checked={valuesArray.findIndex((item) => item === option) > -1}
                  />
                )}
                label={translations[`_o${sharedId}_${option}`] || option} // Si la opció no està traduida, es mostra option
              />
            ))}
          </FormGroup>
          {translations[`_f01${sharedId}`] && <Typography variant='body1' component='div' className={varStyle.footer}>{translations[`_f01${sharedId}`]}</Typography>}
          <FormHelperText error={showError}>{showError ? errors[field.name] : ''}</FormHelperText>
        </FormControl>
      </Grid>
    </Grid>
  );
}

export default Multiple;

// Indica i controla els props que se han de passar al component
Multiple.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  handleResult: PropTypes.func.isRequired,
  handleResultMultiple: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  sharedId: PropTypes.string.isRequired,
};
